/** @format */

import {
  Button,
  Column,
  DataTable,
  DataTableSkeleton,
  FilterableMultiSelect,
  Grid,
  PaginationNav,
  Row,
  Table,
  TableBatchAction,
  TableBatchActions,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeader,
  TableRow,
  TableSelectAll,
  TableSelectRow,
  TableToolbar,
  TableToolbarContent,
  TableToolbarSearch,
} from "carbon-components-react";
import dayjs from "dayjs";
import { connect, useSelector } from "react-redux";
import { SORT_BY_TYPES_UP } from "../utils/constants";

function UIShellPagination({
  isLoading,
  dataTableList = [],
  headers = [],
  searchTable,
  onApplyFilter,
  bulkDelete,
  createForm,
  viewDetail,
  paginationChange,
  totalItems,
  page,
  withPagination = true,
  withCreatable = true,
  withTitle = true,
  withDelete = true,
  title,
  description,
  isHtmlContent = false,
  styles = {
    grid: {},
  },
  filterComp,
  onSort,
}) {
  const accountTypeUser = useSelector(
    (state) => state.accountReducer.accountType,
  );

  const showDeleteButton = accountTypeUser !== "CONTENT_MANAGER";

  const getCellValue = (value) => {
    switch (value) {
      case true:
        return "Yes";
      case false:
        return "No";
      case null:
        return "No";
      case undefined:
        return "No";
      default:
        return String(value);
    }
  };

  const handleSort = (a, b, { key, sortDirection }) => {
    if (key === "createdAt") {
      onSort(SORT_BY_TYPES_UP.DATE, sortDirection);
    }

    if (key === "projectsNumber") {
      onSort(SORT_BY_TYPES_UP.NUMBER, sortDirection);
    }
  };

  const dataTableRows = dataTableList?.map((v) => {
    return {
      ...v,
      id: v._id,
      isFeatured: getCellValue(v.isFeatured),
      isActive: getCellValue(v.isActive),
      isEmailConfirmed: getCellValue(v.isEmailConfirmed),
      isEmailNotification: getCellValue(v.isEmailNotification),
    };
  });

  return (
    <Grid fullWidth={true} style={styles.grid}>
      {filterComp && <>{filterComp}</>}
      <Row>
        <Column>
          <DataTable
            rows={dataTableRows?.map((v) => ({
              ...v,
              id: v._id,
            }))}
            headers={headers}
            sortRow={handleSort}
          >
            {({
              rows,
              headers,
              selectedRows,
              getSelectionProps,
              getTableProps,
              getHeaderProps,
              getRowProps,
              getToolbarProps,
              getBatchActionProps,
            }) => (
              <TableContainer
                title={title ? title : ""}
                description={description ? description : ""}
              >
                {withDelete && (
                  <TableToolbar {...getToolbarProps()}>
                    {showDeleteButton && (
                      <TableBatchActions {...getBatchActionProps()}>
                        <TableBatchAction
                          tabIndex={
                            getBatchActionProps().shouldShowBatchActions
                              ? 0
                              : -1
                          }
                          onClick={() => bulkDelete(selectedRows)}
                        >
                          Delete
                        </TableBatchAction>
                      </TableBatchActions>
                    )}
                    {withCreatable && (
                      <>
                        <TableToolbarContent>
                          <TableToolbarSearch onChange={searchTable} />
                          {onApplyFilter && (
                            <div className="filterBox">
                              <FilterableMultiSelect
                                id="carbon-multiselect-example"
                                itemToString={(item) => (item ? item.text : "")}
                                items={[
                                  {
                                    id: "published",
                                    text: "Published",
                                  },
                                  {
                                    id: "featured",
                                    text: "Featured",
                                  },
                                ]}
                                label="Filter by"
                                onChange={onApplyFilter}
                                // onMenuChange={(e) => {
                                //   console.info(e);
                                // }}
                              />
                            </div>
                          )}
                          <Button onClick={() => createForm()}>
                            Create New
                          </Button>
                        </TableToolbarContent>
                      </>
                    )}
                  </TableToolbar>
                )}
                <Table {...getTableProps()}>
                  <TableHead>
                    <TableRow>
                      {withDelete && (
                        <TableSelectAll {...getSelectionProps()} />
                      )}
                      {headers.map((header) => (
                        <TableHeader
                          {...getHeaderProps({
                            header,
                            isSortable:
                              header.key === "createdAt" ||
                              header.key === "projectsNumber",
                          })}
                        >
                          {header.header}
                        </TableHeader>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.map((row) => (
                      <TableRow {...getRowProps({ row })}>
                        {withDelete && (
                          <TableSelectRow {...getSelectionProps({ row })} />
                        )}
                        {row.cells.map((cell) => (
                          <TableCell
                            onClick={() => viewDetail(row.cells)}
                            key={cell.id}
                          >
                            {cell.info.header === "profilePicture" ? (
                              <img
                                style={{ width: 100, padding: 10 }}
                                src={cell.value}
                              />
                            ) : cell.info.header === "createdAt" ? (
                              <> {dayjs(cell.value).format("DD.MM.YYYY")}</>
                            ) : (isHtmlContent &&
                                cell.info.header === "content") ||
                              (isHtmlContent &&
                                cell.info.header === "description") ? (
                              <div
                                className="blockOverflow"
                                dangerouslySetInnerHTML={{ __html: cell.value }}
                              ></div>
                            ) : (
                              <>{cell.value}</>
                            )}
                          </TableCell>
                        ))}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </DataTable>
        </Column>
      </Row>
      {withPagination && (
        <Row>
          <Column>
            {totalItems > 0 && (
              <PaginationNav
                onChange={paginationChange}
                totalItems={totalItems}
                page={page}
              />
            )}
          </Column>
        </Row>
      )}
    </Grid>
  );
}

const mapStateToProps = (state) => {
  return {
    isLoading: state.uxReducer.isLoading,
  };
};

export default connect(mapStateToProps)(UIShellPagination);
